import React from "react";
import Spinner from "../../../components/presentationals/Spinner";
import Error from "../../../components/Error/index";
import CustomCard from "../../../components/customCard/index";
import { lmtdCheck } from "../../../utils/common/index";

const DeviceSalesDistributionTabsView = ({
  distributionObj,
  url,
  headerSelectedDateFrom,
  headerSelectedDateTo,
  csvEndPointUrl,
  isCsvActive,
  fetchCsvData,
  csvLoading,
  dashboardName,
  viewName,
}) => {
  const endpointData = distributionObj && distributionObj.distributionTableData;
  const tableContainedData =
    endpointData && endpointData[url] && endpointData[url][0];

  return (
    <>
      {distributionObj.loading ? (
        <Spinner />
      ) : tableContainedData ? (
        <>
          <div className="d-block d-sm-none col-12">
            <div
              id="carousel-div"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#carousel-div"
                  data-bs-slide-to="0"
                  className="active"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carousel-div"
                  data-bs-slide-to="1"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carousel-div"
                  data-bs-slide-to="2"
                ></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <CustomCard
                    tileName="Billed"
                    csvName="Billed"
                    lmtd={
                      lmtdCheck(headerSelectedDateFrom, headerSelectedDateTo)
                        ? tableContainedData.billedLMTD
                        : ""
                    }
                    value={tableContainedData.billed}
                    csv={csvEndPointUrl}
                    csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                    gradient="1"
                    loading={csvLoading}
                    dashboardName={dashboardName}
                    viewName={viewName}
                  />
                </div>
                <div className="carousel-item">
                  <CustomCard
                    tileName="On Boarded"
                    csvName="On Boarded"
                    value={tableContainedData.onBoarded}
                    csv={csvEndPointUrl}
                    csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                    gradient="2"
                    loading={csvLoading}
                    dashboardName={dashboardName}
                    viewName={viewName}
                  />
                </div>
                <div className="carousel-item">
                  <CustomCard
                    tileName="Percentage Billed"
                    value={tableContainedData.percentageBilled}
                    percentage={true}
                    gradient="3"
                    dashboardName={dashboardName}
                    viewName={viewName}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-none d-sm-block col-12">
            <div className="row">
              <CustomCard
                tileName="Billed"
                csvName="Billed"
                lmtd={
                  lmtdCheck(headerSelectedDateFrom, headerSelectedDateTo)
                    ? tableContainedData.billedLMTD
                    : ""
                }
                value={tableContainedData.billed}
                csv={csvEndPointUrl}
                csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                gradient="1"
                loading={csvLoading}
                dashboardName={dashboardName}
                viewName="Distribution"
              />
              <CustomCard
                tileName="On Boarded"
                csvName="On Boarded"
                value={tableContainedData.onBoarded}
                csv={csvEndPointUrl}
                csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                gradient="2"
                loading={csvLoading}
                dashboardName={dashboardName}
                viewName="Distribution"
              />
              <CustomCard
                tileName="Percentage Billed"
                value={tableContainedData.percentageBilled}
                percentage={true}
                gradient="3"
                dashboardName={dashboardName}
                viewName="Distribution"
              />
            </div>
          </div>
        </>
      ) : (
        <Error error={distributionObj.error} />
      )}
    </>
  );
};

export default DeviceSalesDistributionTabsView;
